import { Link } from "react-router-dom";

import "./footer.css";

function Footer() {
    return <div className="footer">
        <p>
            <a href="tel:+49 89 43630078">+49 89 43630078</a><br/>
            <a href="mailto:info@solveig-bissinger.de">info@solveig-bissinger.de</a>
        </p>
        <Link to="/links" >Weiterführende Links</Link>
        <Link to="/kontakt" >Kontakt</Link>
        <Link to="/impressum" >Impressum</Link>
        <Link to="/datenschutz" >Datenschutz</Link>
        <p>© Solveig Marita Bissinger 2026</p>
    </div>
}

export default Footer;